import { useQuery } from "@apollo/client";
import { GET_ALL_CAMPAIGNS } from "../../../utils/api/campaign";
import HomeList from "./HomeList";


const RecentList = () => {
  const {
    loading,
    error,
    data,
  } = useQuery(GET_ALL_CAMPAIGNS, {
    variables: {
      sort: {
        column:'createdAt',
        direction: 'DESC'
      },
    },
  });

  const campaigns = data?.campaigns?.items || []

  return <HomeList campaigns={campaigns} loading={loading} error={error} />
};

export default RecentList;
